import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const AddActionTaken = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Validate form fields
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

   

    console.log("formData", formData);

    // Show confirmation alert
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
  if (!result.isConfirmed) {
    //setLoading(false); 
    Swal.fire({
      title: "Cancelled",
      text: "The action has been cancelled.",
      icon: "info",
      confirmButtonText: "OK",
    });

    return;
  }
    const loadingAlert = Swal.fire({
      title: "Processing...",
      text: "Please wait while we add the record.",
      icon: "info",
      allowOutsideClick: false, // Prevent dismissing the alert
      didOpen: () => {
        Swal.showLoading(); // Show loading indicator
      },
    });

    try {
      setLoading(true); // Start loading
      const payload = {
        action_taken_name: formData.action_taken_name,
        action_taken_desc: formData.action_taken_desc,
        status: formData.status === "Active" ? 1 : 0,
      };
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
      const response = await axiosInstance.post(
        "/actiontaken/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        Swal.close();
        Swal.fire({
          title: "Success",
          text: "Action taken added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/admin/manage-lead/action-taken"); // Navigate after user clicks OK
        });
      }
    } catch (error) {
      console.error("Error adding action taken:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      Swal.close();
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "action_taken_name",
      label: "Name",
      type: "text",
      placeholder: "Enter Action Taken Name",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "action_taken_desc",
      label: "Description",
      placeholder: "Enter Action Taken Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const handleNavigate = () => {
    navigate("/admin/manage-lead/action-taken");
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div onClick={handleNavigate} className="backbutton mt-2 mb-2">
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add Action Taken</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Action Taken Details
            </span>
            <DynamicForm
              formConfig={CustomerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddActionTaken;
